export enum ResultLayer {
  BOX = 'mitra-result-box',
  BOX_LABELS = 'mitra-result-box-labels',
  VERTEX = 'mitra-result-vertex',
  VERTEX_LABELS = 'mitra-result-vertex-labels',
  BUILDING_LABELS = 'mitra-result-building-labels',
  TRUNK_CABLES = 'mitra-result-trunk-cables',
  DIST_CABLES = 'mitra-result-dist-cables',
  CTOP_CABLES = 'mitra-result-ctop-cables',
  CDOI_CABLES = 'mitra-result-cdoi-cables',
  CABLE_LABELS = 'mitra-result-cable-labels',
}
